import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Fahrzeug} from './fahrzeuge.model';
import {LocalStorageService} from '../share/localstorage.service';
import {Router} from '@angular/router';
import {SyncService} from '../share/sync.service';
import {IDBPDatabase, openDB} from 'idb';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-fahrzeuge',
    templateUrl: './fahrzeuge.component.html',
    styleUrls: ['./fahrzeuge.component.css'],
    standalone: false
})
export class FahrzeugeComponent implements OnInit, OnDestroy {
    public Ueberschrift: string = this.ls.get('APP_Ueberschrift');
    public Fahrzeuge: Fahrzeug[] = [];
    public aktiver_bereich = 0;
    private db: IDBPDatabase;
    private subscription;
    public anzeigeBereich0 = false;
    public anzeigeBereich1 = false;
    public anzeigeBereich2 = false;
    public anzeigeBereich3 = false;
    public anzeigeBereich4 = false;
    public anzeigeBereich5 = false;
    public anzeigeBereich6 = false;

    public zahlBereich0 = 0;
    public zahlBereich1 = 0;
    public zahlBereich2 = 0;
    public zahlBereich3 = 0;
    public zahlBereich4 = 0;
    public zahlBereich5 = 0;
    public zahlBereich6 = 0;

    @ViewChild('hash_fzgStatus') private myScrollContainer: ElementRef;

    constructor(private http: HttpClient,
                private SyncService: SyncService,
                private ls: LocalStorageService) {
    }


    ngOnInit() {
        // Sync starten, falls es ein dirket Aufruf der URL ist
        this.SyncService.sync('');


        this.getFahrzeugData().then(() => {

            this.ZahlproBereich();

            this.Bereichanzeigen();


        });


        // Um ohne User_Key wieder zurück ins Hauptmenü zu kommen!!
        /* if (this.ls.get('User_Key') === undefined ||
             this.ls.get('User_Key') === 'undefined' ||
             this.ls.get('User_Key') === '' ||
             this.ls.get('User_Key') === null) {
             this.router.navigate(['/']).then(function () {
             });
         }*/
        // --------------------------------------------

        //if (this.ls.get_FahrzeugeItems() == null) {
        // this.sync.getData('fahrzeuge', 'force');
        //}

        // Um erstmal Daten zu bekommen
        //this.Fahrzeuge = this.ls.get_FahrzeugeItems();


        // Subscription für die Aktualisierung zwischendurch
        this.subscription = this.SyncService.FahrzeugeDataChanged
            .subscribe(() => {
                    this.getFahrzeugData().then(() => {

                        this.ZahlproBereich();

                    });

                    //this.ZahlproBereich();
                }
            );
    }


    changestatus(issi) {
        const wert = prompt('Passwort+Status?');
        if (wert.substring(0, 2) == '13') { // Ein Teil des Passwortes, rest in PHP
            const params = new HttpParams()
                .set('MachineId', String(localStorage.getItem('MachineId')))
                .set('AuthentificationKey', String(localStorage.getItem('AuthentificationKey')))
                .set('action', 'ChangeFzgStatus')
                .set('issi', issi)
                .set('value', wert)
                .set('random', Math.random().toString());


            this.http.get('https://fappback.devhm.de/status_save.php', {params})
                .subscribe((reponse: string) => {
                    this.SyncService.GetDataFromWeb(''); //true damit auch die neuen Daten gankkommen
                });
        }
    }


    async getFahrzeugData() {
        await this.open_db()
            .then(() => {

                let data = this.db.getAll('fmsstatus');

                return data;
            }).then((data) => {
                this.Fahrzeuge = data;
            });
    }

    async open_db() {       // Prüft ob die DB vorhanden ist, legt diese sonst an!
        this.db = await openDB('fapp-store', 1, {});
    }


    Bereichanzeigen() {
        this.Fahrzeuge.forEach(Element => {
            if (Element.bereich == '0') {
                this.anzeigeBereich0 = true;
            } else if (Element.bereich == '1') {
                this.anzeigeBereich1 = true;
            } else if (Element.bereich == '2') {
                this.anzeigeBereich2 = true;
            } else if (Element.bereich == '3') {
                this.anzeigeBereich3 = true;
            } else if (Element.bereich == '4') {
                this.anzeigeBereich4 = true;
            } else if (Element.bereich == '5') {
                this.anzeigeBereich5 = true;
            } else {
                this.anzeigeBereich6 = true;
            }
        });
    }

    ZahlproBereich() {
        this.zahlBereich0 = 0;
        this.zahlBereich1 = 0;
        this.zahlBereich2 = 0;
        this.zahlBereich3 = 0;
        this.zahlBereich4 = 0;
        this.zahlBereich5 = 0;
        this.zahlBereich6 = 0;

        this.Fahrzeuge.forEach(Element => {
            if (Element.bereich == '0' && Element.status !== '2') {
                this.zahlBereich0++;
            } else if (Element.bereich == '1' && Element.status !== '2' && Element.status !== '0') {
                this.zahlBereich1++;
            } else if (Element.bereich == '2' && Element.status !== '2' && Element.status !== '0') {
                this.zahlBereich2++;
            } else if (Element.bereich == '3' && Element.status !== '2' && Element.status !== '0') {
                this.zahlBereich3++;
            } else if (Element.bereich == '4' && Element.status !== '2' && Element.status !== '0') {
                this.zahlBereich4++;
            } else if (Element.bereich == '5' && Element.status !== '2' && Element.status !== '0') {
                this.zahlBereich5++;
            } else if (Element.status !== '2' && Element.status !== '0') {
                this.zahlBereich6++;
            }
        });
    }

    select_bereich(id) {
        this.aktiver_bereich = id;
        for (let i = 0; i <= 6; i++) {
            let button = <HTMLImageElement>document.getElementById('btn_' + i);
            if (i == 0) {
                button.src = './assets/images/amt.png';
            } else if (i == 6) {
                button.src = './assets/images/bereich_son.png';
            } else {
                button.src = './assets/images/bereich_' + i + '.png';
            }
        }

        let button = <HTMLImageElement>document.getElementById('btn_' + id);
        if (id == 0) {
            button.src = './assets/images/amt_active.png';
        } else if (id == 6) {

            button.src = './assets/images/bereich_son_active.png';
        } else {
            button.src = './assets/images/bereich_' + id + '_active.png';
        }


    }


    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
